import { generateReducer } from "../generators/generator.reducer";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./document.constants";
export var REDUCER_KEY_DOCUMENT = REDUCER_KEY;
var getExtraDefaultState = function (state) { return ({}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
// eslint-disable-next-line import/no-default-export
export default reducer;
